import Vue from "vue"

export const contestGroupStore = {
  state: {
    contest_group: [],
    campaign: {},
    badges: [],
    generated_at: '',
    exclusiveFilter: '',
    activeFilters: [],
  },
  mutations: {
    CHANGE_EXCLUSIVE_FILTER(state, filter) {
      if (state.exclusiveFilter === filter) {
        Vue.set(state, 'exclusiveFilter', '')
      } else {
        Vue.set(state, 'exclusiveFilter', filter)
      }
    },
    CHANGE_ACTIVE_FILTERS(state, filter) {
      const index = state.activeFilters.indexOf(filter)
      if (index === -1) {
        Vue.set(state.activeFilters, state.activeFilters.length, filter)
      } else {
        Vue.delete(state.activeFilters, index)
      }
    },
    CLEAR_FILTERS(state) {
      Vue.set(state, 'exclusiveFilter', '')
      Vue.set(state, 'activeFilters', [])
    },
    SET_CONTEST_GROUP(state, contest_group) {
      Vue.set(state, 'contest_group', contest_group)
    },
    SET_CAMPAIGN(state, campaign) {
      Vue.set(state, 'campaign', campaign)
    },
    SET_GENERATED_AT(state, generated_at) {
      Vue.set(state, 'generated_at', generated_at)
    },
    SET_BADGES(state, badges) {
      // платные места последней вкладкой
      const sortedBadges = [...badges].sort((a, b) => {
        if (a.text === "Платные места") return 1
        if (b.text === "Платные места") return -1
        return 0
      })

      Vue.set(state, 'badges', sortedBadges)
    }
  },
  actions: {
    async getContestGroup({ commit }, {education_level, edu_form, contest_group_id}) {
      try {
        const data = await Vue.http.get(`/api/v1/campaigns/${education_level}/${edu_form}/contest_groups/${contest_group_id}`)
        commit('SET_CAMPAIGN', data.body.campaign)
        commit('SET_GENERATED_AT', data.body.generated_at)
        commit('SET_CONTEST_GROUP', data.body.contest_group)
        commit('SET_BADGES', data.body.badges)
        return data
      } catch(error) {
        throw error
      }
    }
  }
}